(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["description_tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('description-tabs')) {
    class DescriptionTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (!this.tabs.length) return;

        this.onClick = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab || !this.contains(tab)) return;
          this.select(this.tabs.indexOf(tab), false);
        };

        this.onKeydown = (event) => {
          const current = this.tabs.indexOf(event.target.closest('[role="tab"]'));
          if (current < 0) return;
          let next = null;
          const isRtl = getComputedStyle(this).direction === 'rtl';

          if (event.key === 'ArrowRight') next = isRtl ? current - 1 : current + 1;
          if (event.key === 'ArrowLeft') next = isRtl ? current + 1 : current - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === null) return;

          event.preventDefault();
          next = (next + this.tabs.length) % this.tabs.length;
          this.select(next, true);
        };

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);

        // If the chosen default tab doesn't exist (e.g. it's empty), open the first one
        if (!this.tabs.some((tab) => tab.getAttribute('aria-selected') === 'true')) {
          this.select(0, false);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
      }

      select(index, focus) {
        this.tabs.forEach((tab, i) => {
          const isActive = i === index;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
          if (this.panels[i]) this.panels[i].hidden = !isActive;
        });

        const activeTab = this.tabs[index];
        if (!activeTab) return;
        if (focus) activeTab.focus();

        // Keep the active tab visible when the tab row scrolls on mobile
        const list = activeTab.parentElement;
        if (list && list.scrollWidth > list.clientWidth) {
          const left = activeTab.offsetLeft - (list.clientWidth - activeTab.offsetWidth) / 2;
          list.scrollTo({ left, behavior: 'smooth' });
        }
      }
    }

    customElements.define('description-tabs', DescriptionTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
